import React from 'react';
import { OnamCelebration2026 } from '../views';


const SchoolProgrampage = () => {
  return <OnamCelebration2026/>;
};

export default SchoolProgrampage;